export default __webpack_public_path__ + "static/media/educator-questionnaire-box.67328a72.svg";